import { Injectable } from '@angular/core';
import { PhxContextService, PHOENIX_CONTEXTS } from './phx-context-service';

@Injectable()
export class PhxSortItemService extends PhxContextService {
  
  constructor() {
    super();
  }

  public getType(): PHOENIX_CONTEXTS {
    return PHOENIX_CONTEXTS.SORT_ITEM;
  }
}
